/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Droplinknone2Inputs */

const en_droplinknone2 = /** @type {(inputs: Droplinknone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing`)
};

const de_droplinknone2 = /** @type {(inputs: Droplinknone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nichts`)
};

/**
* | output |
* | --- |
* | "Nothing" |
*
* @param {Droplinknone2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const droplinknone2 = /** @type {((inputs?: Droplinknone2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Droplinknone2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_droplinknone2(inputs)
	return de_droplinknone2(inputs)
});
export { droplinknone2 as "dropLinkNone" }